import Home from "./pages/Home/Home.jsx";
import Login from "./pages/Login/Login.jsx";
import Listado from "./pages/List/Listado.jsx";
import Visitor from "./pages/visitor/Visitor.jsx";
import New from "./pages/form/Formu.jsx";
import {Route,Routes,BrowserRouter,Navigate} from "react-router-dom";
import NotFound from "./pages/NotFound/NotFound.jsx";
import { AuthContext } from "./Context/AuthContext.js";
import { useContext } from "react";
import DeadLine from "./pages/DeadLine/NotFound.jsx";


function App() {

const { user } = useContext(AuthContext);

  const RequireAuth = ({ children }) => {
    return user ? children: <Navigate to="/"/>;
  };
    return(
        <div>
            <BrowserRouter>
             <Routes>
                <Route path="/" element={<Login/>}/>
                <Route path="/admin" element={<RequireAuth><Home/></RequireAuth>}/>
                <Route path="/admin/eventos/nuevo" element={<RequireAuth><New/></RequireAuth>}/>
                <Route path="/admin/eventos/:id" element={<RequireAuth><Listado/></RequireAuth>}/>
                <Route path="/:name" element={<Visitor/>} />
                <Route path="*" element={<RequireAuth><NotFound/></RequireAuth>}/>
                <Route path="/NotFound" element={<RequireAuth><DeadLine/></RequireAuth>}/>

                {/* <Route path="/admin" element={loggedIn != null ? <Home/> : <Navigate replace to="/login"/>} /> */}
            </Routes>
            </BrowserRouter>
        </div>
    )
}


export default App;